var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    {
      ref: "formItem",
      attrs: {
        "label-width": _vm.$attrs["label-width"],
        prop: _vm.$attrs["prop"],
        label: _vm.$attrs["label"],
      },
    },
    [
      _c(
        "el-input-number",
        _vm._b(
          {
            attrs: { autocomplete: "off", controls: false },
            on: {
              change: function (value) {
                return _vm.setModel(value)
              },
            },
            model: {
              value: _vm.innerValue,
              callback: function ($$v) {
                _vm.innerValue = $$v
              },
              expression: "innerValue",
            },
          },
          "el-input-number",
          Object.assign({}, _vm.$attrs),
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }